import template from './drgs.html';
import controller from './drgs.controller';
import './drgs.styl';

let drgsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default drgsComponent;



// WEBPACK FOOTER //
// ./client/app/common/admin/drgs/drgs.component.js